import {Action} from '@ngrx/store';
import {DocumentInfo} from '../models/document-info';
import {DocumentMaster} from '../models/document-master';
import {KvItem} from '../../core/models/kv-item';
import { DownloadedDocument } from 'app/modules/document/models/downloaded-document';
import { ErrorModel } from '../../core/models/error-model';

export const UPLOAD_FILE = '[document] UploadFile';
export const UPLOAD_FILE_COMPLETE = '[document] UploadFileComplete';
export const ATTACH_METADATA_TO_FILE = '[document] AttachMetadataToFile';
export const ATTACH_METADATA_TO_FILE_COMPLETE = '[document] AttachMetadataToFileComplete';
export const DOWNLOAD_FILE = '[document] DownloadFile';
export const DOWNLOAD_FILE_COMPLETE = '[document] DownloadFileComplete';
export const RETRIEVE_METADATA = '[document] RetrieveMetadata';
export const RETRIEVE_METADATA_COMPLETE = '[document] RetrieveMetadataComplete';
export const RETRIEVE_METADATA_FOR_IDS = '[document] RetrieveMetadataForIds';
export const RETRIEVE_METADATA_FOR_IDS_COMPLETE = '[document] RetrieveMetadataForIdsComplete';
export const RETRIEVE_ALL_ACTIVE = '[document] RetrieveAllActiveMetadata';
export const RETRIEVE_ALL_ACTIVE_COMPLETE = '[document] RetrieveAllActiveMetadataComplete';
export const RETRIEVE_ALL_DELETED = '[document] RetrieveAllDeletedMetadata';
export const RETRIEVE_ALL_DELETED_COMPLETE = '[document] RetrieveAllDeletedMetadataComplete';
export const REMOVE_DOCUMENT = '[document] RemoveDocument';
export const REMOVE_DOCUMENT_COMPLETE = '[document] RemoveDocumentComplete';
export const RESET_DOCUMENT_UPLOAD = '[document] ResetDocumentUpload';
export const SORT_DOCUMENT_LIST = '[document] SortFileList';
export const GET_FILE_VIEW_URL = '[document] GetFileViewUrl';
export const GET_FILE_VIEW_URL_COMPLETE = '[document] GetFileViewUrlComplete';
export const CLEAR_FILE_VIEW_URL = '[document] ClearViewUrl';

export class UploadFileAction implements Action {
  readonly type = UPLOAD_FILE;

  constructor(public payload: DocumentInfo) {}
}

export class UploadFileCompleteAction implements Action {
  readonly type = UPLOAD_FILE_COMPLETE;

  constructor(public payload: KvItem) {}
}

export class AttachMetadataToFileAction implements Action {
  readonly type = ATTACH_METADATA_TO_FILE;

  constructor(public payload: DocumentMaster) {}
}

export class AttachMetadataToFileCompleteAction implements Action {
  readonly type = ATTACH_METADATA_TO_FILE_COMPLETE;

  constructor(public payload: number) {}
}

export class DownloadFileAction implements Action {
  readonly type = DOWNLOAD_FILE;

  constructor(public payload: KvItem) {}
}

export class DownloadFileCompleteAction implements Action {
  readonly type = DOWNLOAD_FILE_COMPLETE;

  constructor(public payload: DownloadedDocument) {}
}

export class RetrieveMetadataAction implements Action {
  readonly type = RETRIEVE_METADATA;

  constructor(public payload: number) {}
}

export class RetrieveMetadataCompleteAction implements Action {
  readonly type = RETRIEVE_METADATA_COMPLETE;

  constructor(public payload: DocumentMaster) {}
}

export class RetrieveMetadataForIdsAction implements Action {
  readonly type = RETRIEVE_METADATA_FOR_IDS;

  constructor(public payload: number[]) {}
}

export class RetrieveMetadataForIdsCompleteAction implements Action {
  readonly type = RETRIEVE_METADATA_FOR_IDS_COMPLETE;

  constructor(public payload: DocumentMaster[]) {}
}

export class RetrieveAllActiveAction implements Action {
  readonly type = RETRIEVE_ALL_ACTIVE;
}

export class RetrieveAllActiveCompleteAction implements Action {
  readonly type = RETRIEVE_ALL_ACTIVE_COMPLETE;

  constructor(public payload: DocumentMaster[]) {}
}

export class RetrieveAllDeletedAction implements Action {
  readonly type = RETRIEVE_ALL_DELETED;
}

export class RetrieveAllDeletedCompleteAction implements Action {
  readonly type = RETRIEVE_ALL_DELETED_COMPLETE;

  constructor(public  payload: DocumentMaster[]) {}
}

export class RemoveDocumentAction implements Action {
  readonly type = REMOVE_DOCUMENT;

  constructor(public payload: number) {}
}

export class RemoveDocumentCompleteAction implements Action {
  readonly type = REMOVE_DOCUMENT_COMPLETE;

  constructor(public payload: boolean) {}
}

export class ResetDocumentUploadAction implements Action {
  readonly type = RESET_DOCUMENT_UPLOAD;
}

export class SortDocumentListAction implements Action {
  readonly type = SORT_DOCUMENT_LIST;

  constructor(public payload: string) {}
}

export class GetFileViewUrlAction implements Action {
  readonly type = GET_FILE_VIEW_URL;

  constructor(public payload: number) { }
}

export class GetFileViewUrlCompleteAction implements Action {
  readonly type = GET_FILE_VIEW_URL_COMPLETE;

  constructor(public payload: string) { }
}

export class ClearFileViewUrl implements Action {
  readonly type = CLEAR_FILE_VIEW_URL;
}

export type Actions = UploadFileAction |
  UploadFileCompleteAction |
  AttachMetadataToFileAction |
  AttachMetadataToFileCompleteAction |
  DownloadFileAction |
  DownloadFileCompleteAction |
  RetrieveMetadataAction |
  RetrieveMetadataCompleteAction |
  RetrieveMetadataForIdsAction |
  RetrieveMetadataForIdsCompleteAction |
  RetrieveAllActiveAction |
  RetrieveAllActiveCompleteAction |
  RetrieveAllDeletedAction |
  RetrieveAllDeletedCompleteAction |
  RemoveDocumentAction |
  RemoveDocumentCompleteAction |
  ResetDocumentUploadAction |
  SortDocumentListAction |
  GetFileViewUrlAction |
  GetFileViewUrlCompleteAction |
  ClearFileViewUrl;



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/document/actions/document.ts